import { IoClose, IoRefresh } from 'react-icons/io5';
import strings from './admin.translations';

export const deactivateReactivateTabConfig = {
  active: { icon: IoClose, label: strings.common.deactivate },
  inactive: { icon: IoRefresh, label: strings.common.reactivate }
} as const;
